import { Major, ChartCard } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { getGradSchoolNecessityPercent } from '@backrs_ui/grow-ui/src/pages/Majors/majors.utils';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { useAgentContext } from './GraduateSchoolSection.agentContext';

const STRINGS = appStrings.modules.majors.graduateSchool;

type GraduateSchoolSectionProps = Readonly<{
  major: Major;
}>;

export function GraduateSchoolSection({ major }: GraduateSchoolSectionProps) {
  useAgentContext(major);

  const necessityPercent = getGradSchoolNecessityPercent(major.gradSchoolNecessity || '');

  return (
    <Box sx={contentContainerSx}>
      {/* Left Side - Necessity Card */}
      <ChartCard
        title={STRINGS.necessity}
        chartVariant={{
          type: 'PROGRESS_CIRCLE',
          text: major.gradSchoolNecessity,
          progressCircle: {
            percent: necessityPercent,
          },
        }}
        overrideSx={{
          container: {
            minHeight: '100%',
            flex: '1 1 min(535px, 100%)',
            minWidth: 0,
          },
        }}
        additionalInfoVariant={{
          type: 'TOOLTIP',
          toolTipText: STRINGS.necessityInfo,
        }}
      />

      {/* Right Side - Rationale Text */}
      <Box sx={rationaleContainerSx}>
        <Typography variant="text-md-regular" sx={rationaleTextSx}>
          {major.gradSchoolNecessityRationale}
        </Typography>
      </Box>
    </Box>
  );
}

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-4xl'],
  alignItems: 'flex-start',
});

const rationaleContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: backrs.spacing['spacing-2xl'],
  flex: '1 1 280px',
  maxWidth: '280px',
});

const rationaleTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});
